// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb09a3b9","455":"83d9cd63"}[chunkId] + ".chunk.js";
};